const operationTypes = {
  'write-off': 'Списание',
  'replenishment': 'Пополнение',
}

export const operationTypeRender = (text, record) => {
  return operationTypes[text];
}